import { useEffect, useRef, useState } from "react";
import './index.scss';
import { Outlet, useLocation } from "react-router-dom";
import { MENUPOSITION } from "../../../dashboard/model";
// import SideBarGuestDynamic from "../../../dashboard/side-bars/sidebar-user/SideBarGuestDynamic";
import SideBarGuest from "../../../dashboard/side-bars/sidebar-user/SideBarGuest";
import { useDssContext } from "../../../../DSSContext";
import SideBarGuestDynamic from "../../../dashboard/side-bars/sidebar-user/SideBarGuestDynamic";

export const GuestLayoutSide = (): JSX.Element => {
  const { active, setActive } = useDssContext();
  const outletContainerRef = useRef<HTMLElement | null>(null);
  const [openSubMenu, setOpenSubMenu] = useState<string | null>(null);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (outletContainerRef.current) {
      outletContainerRef.current.scrollTop = 0;
    }
  }, [location.pathname]);

  const handleMenuClick = () => {
    if (active === '') setActive(' active');
    else setActive('');
    setOpenSubMenu(null);
  };

  return (
    <div className="user-container-left">
      <div className={"left-container" + active}>
        <SideBarGuest
          active={active}
          onMenuClick={handleMenuClick}
          openSubMenu={openSubMenu}
          setOpenSubMenu={setOpenSubMenu}
          data-testid="sidebar-guest"
          menuPosition={MENUPOSITION.VERTICAL}
          leftmenu={!!active}
        />
        {/* <SideBarGuestDynamic
          active={active}
          onMenuClick={handleMenuClick}
          openSubMenu={openSubMenu}
          setOpenSubMenu={setOpenSubMenu}
          data-testid="sidebar-guest-dynamic"
          menuPosition={MENUPOSITION.VERTICAL}
          leftmenu={!!active}
        /> */}
      </div>
      <main ref={outletContainerRef} className={"outlet-container" + active}>
        <Outlet />
      </main>
    </div>
  );
};

export default GuestLayoutSide;
